function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.964 16.993c-1.341-.056-2.438-.445-3.296-1.168a6.795 6.795 0 01-.684-.726 4.62 4.62 0 01-.742-1.415C-.244 12.143.006 10.12.956 7.9c.814-1.9 2.069-3.784 4.259-6.394A136.84 136.84 0 016.504 0c.002 0-.05.096-.116.213-.57 1.011-1.057 2.202-1.322 3.233-.426 1.654-.375 3.074.15 4.174.363.759.985 1.415 1.684 1.779 1.223.635 3.014.688 5.202.153.15-.037 7.613-2.137 16.585-4.666C37.657 2.356 44.999.287 45 .289c.002.002-20.842 9.457-31.663 14.362-1.714.777-2.172.973-2.978 1.273-2.06.766-3.904 1.132-5.395 1.07z",
  fill: "#1A1A1A"
});

function SvgNikeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 17,
    viewBox: "0 0 45 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgNikeinline;